import './global';
import {
  FeatureAppDefinition,
  FeatureAppEnvironment,
  FeatureServices,
} from '@feature-hub/core';
import { ReactFeatureApp } from '@feature-hub/react';
import { faContentServiceDefinition } from '@volkswagen-onehub/fa-content-service';
import App from './App';
import '@photo-sphere-viewer/core/index.css'


export const featureAppDefinition: FeatureAppDefinition<ReactFeatureApp> = {
  dependencies: {
    externals: {
      react: '^17.8.2 || ^18.0.0',
      '@feature-hub/react': '^3.0.0',
    },
    featureServices: {
      'fa-content-service': '^1.0.0',
      'tracking-service-config': '^1.0.0',
      'featureapp-service': '^1.0.0',
      tracking: '^1.0.0',
    },
  },
  ownFeatureServiceDefinitions: [faContentServiceDefinition],
  create: (env: FeatureAppEnvironment<FeatureServices, any>) => {
    return {
      render: () => <App aemData={env} />,
    };
  },
};

export default featureAppDefinition;
